import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import './plan.css';
import {
    PaymntSuccess,
} from "../../assets/images";
import { useSelector, useDispatch } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { useEffect } from 'react';
const SuccessEscapeBucks = (props) => {
    const iframeRef = React.useRef < HTMLIFrameElement | null > (null);
    const paymentDetails = useSelector(state => state.changeStep.payment)
    const user = useSelector(state => state.changeStep.tempuser)
    const product = useSelector(state => state.product.details)
    const loginURL = useSelector(state => state.changeStep.login)


    return (

        <div className='sign_up_partts paymnt_parttss'>
            <div className="paymn_success">
                <img src={PaymntSuccess} />
            </div>
            <div className="paymnt_text">
                <h2>Registration Success!</h2>
                <div className='paymnt_type text-center'>
                    <Button variant="primary" type="button" onClick={() => { window.open(loginURL, "_blank") }}>
                            Go To Dashboard
                        </Button >

                    {/* <div className='paymnt_inner_type'>
                        <div className='paymnt_inner_leftts'>Phone</div>
                        <div className='paymnt_inner_rightts'>{payment.mobile}</div>
                    </div>
                    <div className='paymnt_inner_type'>
                        <div className='paymnt_inner_leftts'>Email Address</div>
                        <div className='paymnt_inner_rightts'>{payment.email}</div>
                    </div>
                    <div className='paymnt_inner_type'>
                        <div className='paymnt_inner_leftts'>Amount</div>
                        <div className='paymnt_inner_rightts'>${product.price}</div>
                    </div> */}
                    
                </div>
            </div>
        </div>
    );
};

export default SuccessEscapeBucks;